export class PatientChildren {
  id: number;
  patientId: number;
  name: string;
  middleName: string;
  lastName: string;
  birthDate: Date;
  relationship: string;
  poaLetter: string;
  guardianshipLetter: string;
  gender: string;
  active: boolean;
  age: string;
}
